export const ALLOWED_STACK_VALUES = ['percent', 'normal'];